import { createSelector } from '@reduxjs/toolkit';

import { calendarNavigationKey, CalendarNavigationState } from './calendar-navigation.actions';

export const selectRulerDateRange = createSelector(
    (state: { [calendarNavigationKey]: CalendarNavigationState }) => state[calendarNavigationKey],
    (state: CalendarNavigationState) => state.rulerDateRange,
);
